// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { useTranslation } from "react-i18next";
import { useGroupDetailQuery } from "@/api/hooks/use-groups";
import { DateTimeValue } from "@/components/shared/datetime-value";
import { KeyChip } from "@/components/shared/key-chip";
import { Separator } from "@/components/ui/separator";

interface GroupInfoTabProps {
  groupName: string;
}

export function GroupInfoTab({ groupName }: GroupInfoTabProps) {
  const { t } = useTranslation("back-office");
  const { data } = useGroupDetailQuery(groupName);

  if (!data) return null;

  const { group } = data;

  return (
    <div className="max-w-2xl space-y-6 p-6">
      <div className="grid grid-cols-[160px_1fr] gap-y-3 text-sm">
        <span className="text-muted-foreground">{t("groups.list.columns.id")}</span>
        <span className="tabular-nums">{group.groupId}</span>

        <span className="text-muted-foreground">{t("groups.list.columns.name")}</span>
        <span>
          <KeyChip label={group.name} />
        </span>

        <span className="text-muted-foreground">{t("groups.list.columns.description")}</span>
        {group.description ? <span>{group.description}</span> : <span className="text-muted-foreground">—</span>}

        <Separator className="col-span-2" />

        <span className="text-muted-foreground">{t("groups.list.columns.noOfUsers")}</span>
        <span className="tabular-nums">{group.noOfUsers}</span>

        <Separator className="col-span-2" />

        <span className="text-muted-foreground">{t("common.createdAt")}</span>
        <DateTimeValue value={group.createdAt} />
      </div>
    </div>
  );
}
